import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { scrollToElement } from '@/utils/scroll';

@Component
export class AddressesContainer extends ThemeComponent {
    @Ref({ required: false }) openEditAddressButton!: HTMLButtonElement[];
    @Ref({ required: false }) editAddressForm!: HTMLElement[];
    @Ref({ required: false }) closeEditAddressButton!: HTMLButtonElement[];
    @Ref() openNewAddressButton!: HTMLButtonElement;
    @Ref() newAddressForm!: HTMLElement;
    @Ref() closeNewAddressButton!: HTMLButtonElement;

    init() {

        // Add open edit address event listeners
        this.addOpenEditAddressButtonEventListeners();

        // Add close edit address event listeners
        this.addCloseEditAddressButtonEventListeners();

        // Add open new address event listener
        this.addOpenNewAddressButtonEventListener();

        // Add close new address event listeners
        this.addCloseNewAddressButtonEventListeners();
    }

    addOpenEditAddressButtonEventListeners() {
        for (const editButton of this.openEditAddressButton) {
            this.$listen(editButton, 'click', () => {

                // Hide other edit forms
                for (const addressForm of this.editAddressForm) {
                    addressForm.classList.remove('addresses__form-container--active');
                }

                // Get the correct edit form
                // eslint-disable-next-line max-len
                const editAddressForm = editButton.closest('.addresses__address')?.querySelector('[data-ref="editAddressForm"]');

                // Show edit form
                editAddressForm?.classList.add('addresses__form-container--active');

                // Hide edit button
                editButton.classList.add('hidden');

                // Hide add form
                this.newAddressForm.classList.remove('addresses__form-container--active');

                // Scroll to edit form
                if (editAddressForm) {
                    scrollToElement(editAddressForm as HTMLElement);
                }
            });
        }
    }

    addCloseEditAddressButtonEventListeners() {
        for (const button of this.closeEditAddressButton) {
            this.$listen(button, 'click', () => {

                // Get the correct edit form
                // eslint-disable-next-line max-len
                const editAddressForm = button.closest('.addresses__address')?.querySelector('[data-ref="editAddressForm"]');

                // Hide edit form
                editAddressForm?.classList.remove('addresses__form-container--active');

                // Show edit button
                // eslint-disable-next-line max-len
                const editButton = button.closest('.addresses__address')?.querySelector('[data-ref="openEditAddressButton"]');
                editButton?.classList.remove('hidden');

                // Scroll to address
                scrollToElement(button.closest('.addresses__address'));
            });
        }
    }

    addOpenNewAddressButtonEventListener() {
        if (this.openNewAddressButton) {
            this.$listen(this.openNewAddressButton, 'click', () => {

                // Show add form
                this.newAddressForm.classList.add('addresses__form-container--active');

                // Hide add button
                this.openNewAddressButton.classList.add('hidden');

                // Hide edit forms
                for (const addressForm of this.editAddressForm) {
                    addressForm.classList.remove('addresses__form-container--active');
                }

                // Scroll to add form
                scrollToElement(this.newAddressForm);
            });
        }
    }

    addCloseNewAddressButtonEventListeners() {
        this.$listen(this.closeNewAddressButton, 'click', () => {

            /// Hide add form
            this.newAddressForm.classList.remove('addresses__form-container--active');

            // Show add button
            this.openNewAddressButton.classList.remove('hidden');

            // Scroll to add button
            scrollToElement(this.openNewAddressButton);
        });
    }
}
